import { ICertificateDisplayConfig } from '../interface/index';

const QR_CODE_WIDTH = 88; // 二维码宽度(竖版)
const QR_CODE_HORIZONTAL_WIDTH = 64;// 二维码宽度(横版)
/**
* @desc 获取证书有效期时间展示属性以及时间字段数据
*/
const getElementExhibitConf = (data: ICertificateDisplayConfig) => {
    const {
        setUpInfo = {
            certificateEffective: '',
            certificateEndTime: '',
            validPeriodTime: '',
            certificateIsPermanent: false,
        },
        isShowValidityEndTime,
        isShowValidityStartTime,
    } = data;
    const isShow = !!setUpInfo;
    const isEffective = isShow && !!isShowValidityStartTime && !!setUpInfo.certificateEffective;// 展示有效开始时间
    const isEndTime = isShow && !!isShowValidityEndTime && !!setUpInfo.certificateEndTime;//展示结束时间
    const isShowValidPeriod = isShow && setUpInfo.validPeriodTime || isEffective || isEndTime;// 是否展示时间
    const isShowSplit = isEffective && isEndTime;//是否展示时间分割符号
    return {
        isEndTime,
        isEffective,
        isShowSplit,
        isShowValidPeriod,
        ...setUpInfo
    }
}

export {
    getElementExhibitConf,
    QR_CODE_WIDTH,
    QR_CODE_HORIZONTAL_WIDTH
}
